// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicWebHomepage2 } from "./plasmic/o_21_p_0_0_2_prod/PlasmicWebHomepage2";
import { Helmet } from "react-helmet-async";

function WebHomepage2_(props, ref) {
  return (
        <>
          <Helmet>
            
          </Helmet>
    
          <PlasmicWebHomepage2 root={{ ref }} {...props} />
        </>
      );
}

const WebHomepage2 = React.forwardRef(WebHomepage2_);

export default WebHomepage2;
  